import React from "react";
import styled from "styled-components";
import { theme } from "../../../theme";
import { MIN_MORNITOR_WIDTH } from "../../constants";

const MainContentContainer: React.FC = ({ children }) => {
  return <Container>{children}</Container>;
};
export default MainContentContainer;

const Container = styled.div`
  flex: 1 0 900px;
  height: fit-content;
  display: flex;
  min-height: 100vh;
  max-height: 100vh;
  min-width: 900px;
  flex-direction: column;
  justify-content: center;
  overflow-y: auto;
  overflow-x: hidden;
  @media only screen and (max-width: ${MIN_MORNITOR_WIDTH}) {
    flex-direction: column;
    height: 100vh;
    min-width: unset;
    flex: 1 1 0px;
    background: ${theme.colors.white};
    justify-content: center;
  }
`;
